import { Divider, Typography,Card,Empty,Row,Button,Collapse} from "antd"
import React, { useContext, useEffect, useState } from "react"
import { DescriptionContext } from "../Contexts/AdminProjectContexts";
import ProjectDescriptionForm from "./Form/ProjectDescriptionForm"
import ReactHtmlParser from "react-html-parser";
const {Title,Text}=Typography;
const {Panel}=Collapse

const ProjectDescription = React.memo(function ({ projectId}) {
  const [openModal,setOpenModal]=useState(false)
  const [stateModal, setStateModal] = useState(false);
  // const [descripciónData,setDescriptionData] = useState([]);
  const {
    descriptionProject = [],
    // getDescriptionProject,
    // setDescriptionProject,
    setNeedUpdateDescriptions,
    // needUpdateDescriptions,
  } = useContext(DescriptionContext);

const openModalVisible=(value)=>{
  setOpenModal(value)
}

const requestDescriptionsProject=(value)=>{
  setNeedUpdateDescriptions(value)
}

const createProjectDescriptionData=()=>{
  if(descriptionProject==null){
    setStateModal(true)
  }else{
    setStateModal(false)
    // let data={
    //   summaryExecutive:"",
    //   introduction:"",
    //   background:"",
    //   problem:"",
    //   studyObject:"",
    //   generalObjetive:"",
    //   specificObjetive:"",
    //   fieldAction:"",
    //   workPlan:"",
    //   characteristic:"",
    //   aspiredResult:"",
    //   expectedImpact:"",
    // }
  }
}


useEffect(()=>{
  createProjectDescriptionData()
},[])

    return(
        <>
        <Divider>
          <Title level={4}> Descripción detallada del proyecto</Title>
        </Divider>
        <Row align={"end"}>
         {descriptionProject==null?<Button 
          type="primary" 
          onClick={()=>openModalVisible(true)}
          >+ Añadir descripciones</Button>:
          <Button 
          type="primary" 
          onClick={()=>openModalVisible(true)}
          >+ Editar descripciones</Button>
          }
        </Row>
        {descriptionProject!=null? 
          <Card style={{margin:10}}>
            <Collapse defaultActiveKey={['0']} onChange={(e)=>{console.log(e)}}>
              <Panel header="Resumen ejecutivo" key="1"> 
                <Text>{ReactHtmlParser(descriptionProject.summaryExecutive)}</Text>
              </Panel>
              <Panel header="Introducion" key="2"> 
                <Text>{ReactHtmlParser(descriptionProject.introduction)}</Text>
              </Panel>
              <Panel header="Antecedentes" key="3">
                <Text>{ReactHtmlParser(descriptionProject.background)}</Text> 
              </Panel>
              <Panel header="Caracterización del problema" key="4"> 
                <Text>{ReactHtmlParser(descriptionProject.problem)}</Text>
              </Panel>
              <Panel header="Objetivo de estudio" key="5">
                <Text>{ReactHtmlParser(descriptionProject.studyObject)}</Text> 
              </Panel>
              <Panel header="Objetivo general" key="6">
                <Text>{ReactHtmlParser(descriptionProject.generalObjetive)}</Text>  
              </Panel>
              <Panel header="Objetivos específicos" key="7"> 
                <Text>{ReactHtmlParser(descriptionProject.specificObjetive)}</Text>  
              </Panel>
              <Panel header="Campo de acción" key="8"> 
                <Text>{ReactHtmlParser(descriptionProject.fieldAction)}</Text>  
              </Panel>
              <Panel header="Plan de trabajo" key="9">
                <Text>{ReactHtmlParser(descriptionProject.workPlan)}</Text>   
              </Panel>
              <Panel header="Características epistemológicas y metodológicas" key="10"> 
                <Text>{ReactHtmlParser(descriptionProject.characteristic)}</Text>  
              </Panel>
              <Panel header="Resultados Aspirados" key="11"> 
                <Text>{ReactHtmlParser(descriptionProject.aspiredResult)}</Text>  
              </Panel>
              <Panel header="Impacto Esperado" key="12"> 
                <Text>{ReactHtmlParser(descriptionProject.expectedImpact)}</Text>  
              </Panel>
            </Collapse>
          </Card>
          :
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        }
        <ProjectDescriptionForm 
        openModal={openModal}
        setOpenModalVisible={openModalVisible}
        requestDescriptionsProject={requestDescriptionsProject}
        descriptionProject={descriptionProject}
        ProjectId={projectId}
        stateModal={stateModal}
        />
        </>
    )

})

export default ProjectDescription